export var createMetrics = function createMetrics(emitNotSupportedError, window, wrapSubscribeFunction) {
  return function (options) {
    return wrapSubscribeFunction(function (observer) {
      if (window === null || window.PerformanceObserver === undefined) {
        return emitNotSupportedError(observer);
      }
      var performanceObserver = new window.PerformanceObserver(function (entryList) {
        return observer.next(entryList.getEntries());
      });
      try {
        performanceObserver.observe(options);
      } catch (err) {
        observer.error(err);
      }
      return function () {
        return performanceObserver.disconnect();
      };
    });
  };
};